import type { DOMAttributes } from 'react'
import React from 'react'

type LearnMoreLinkProps = {
  href: string
}

export const LearnMoreLink = ({ href }: LearnMoreLinkProps) => {
  // this component is currently being rendered in another anchor element and this ignores parent click
  const handleClick: DOMAttributes<HTMLAnchorElement>['onClick'] = (event) => {
    event.stopPropagation()
  }

  return (
    <a href={href} target="_blank" rel="noreferrer" onClick={handleClick}>
      Learn more
    </a>
  )
}
